export const coinsWithImageLink = {
    "BTC": {
        "imageUrl": "https://crypto.johnturkson.com/BTC.png",
        "name": "Bitcoin"
    },
    "DOGE": {
        "imageUrl": "https://crypto.johnturkson.com/DOGE.png",
        "name": "Dogecoin"
    },
    "ETH": {
        "imageUrl": "https://crypto.johnturkson.com/ETH.png",
        "name": "Ethereum"
    }
}
